import React from "react";
import { TextField } from "@mui/material";
import DropDownSpecificStaff from "../../Dropdowns/DropDownSpecificStaff";
import InputComponent from "../../InputComponent";
import DatePickerWithTimeComponentNoTitle from "../../DatePickerWithTimeComponentNoTitle";
import DropDownComponentNoTitleNoMargin from "../../DropDownComponentNoTitleNoMargin";
import UploaderDocForNoteV2 from "../../Updloader/UploaderDocForNoteV2";
import UploadedFilesComponentV2 from "../../Updloader/UploadedFilesComponentV2";
import InputComponentNoTitleNomargin from "../../InputComponentNoTitleNomargin";
import DatePickerWithTimeComponentNoTitleNoMargin from "../../DatePickerWithTimeComponentNoTitleNoMargin";
import DropDownComponentSortedNoTitle from "../../DropDownComponentSortedNoTitle";
import SmallClientChipV2LargeMobile from "../../SmallClientChipV2LargeMobile";

function NotesContainerCompactMobileEditContent(props) {
  const {
    modalContent,
    translate,
    noteContent,
    handleNoteContentChange,
    shiftStartRaw,
    handleShiftStartRawChange,
    shiftEndRaw,
    handleShiftEndRawChange,
    staff,
    handleStaffChange,
    effectiveDateTime,
    handleEffectiveDateTimeChange,
    notInAttendance,
    handleNotInAttendanceChange,
    groupTopic,
    handleGroupTopicChange,
    groupType,
    handleGroupTypeChange,
    otherTypeGroupNote,
    handleOtherTypeGroupNoteChange,
    relationship,
    handleRelationshipChange,
    files,
    fileUrls,
    noteId,
    handleFilesChange,
    handleFileRemove,
    deleteFile,
    errors,
    immigrationAppointment,
    setImmigrationAppointment,
    dischargeSwot,
    setDischargeSwot,
    newClients,
    setNewClients,
    medicalInfos,
    setMedicalInfos,
    hospitalAppointment,
    setHospitalAppointment,
    residentialClientMovements,
    setResidentialClientMovements,
    zoomSessionAssistance,
    setZoomSessionAssistance,
    staffToday,
    setStaffToday,
    overnight,
    setOvernight,
    numberOfClient,
    setNumberOfClient,
    swot,
    setSwot,
    generalAnnouncement,
    setGeneralAnnouncement,
  } = props;

  switch (modalContent) {
      case "supportStaffNote":
        return (
          <div>
            <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                {translate("ClientName")}
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  marginTop: "10px",
                  width: "100%",
                  border: "1px solid lightgrey",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SmallClientChipV2LargeMobile
                  firstName={props.clientFirstName}
                  lastName={props.clientLastName}
                  avatar="1"
                  clientPic={props.clientPic}
                />
              </div>
            </div>
            <div style={{ width: "100%", marginTop: "0px", height: "100%" }}>
              <div className="line2-column-modal">
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "10px",
                    paddingBottom: "5px",
                  }}
                >
                  {translate("NoteContent")}
                </div>
                <TextField
                  name="quickNote"
                  value={noteContent}
                  onChange={handleNoteContentChange}
                  style={{
                    width: "95%",
                    borderRadius: "5px",
                  }}
                  placeholder="Type quick session note here"
                  multiline
                  rows={14}
                />
              </div>
              <div
                // className="line3-modal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "20px",
                    paddingLeft: "20px",
                    paddingBottom: "5px",
                  }}
                >
                  {translate("EffectiveDateTime")}
                </div>
                <div style={{ paddingLeft: "15px", marginBottom: "40px" }}>
                  <DatePickerWithTimeComponentNoTitle
                    title={translate("EffectiveDateTime")}
                    value={effectiveDateTime}
                    onChange={handleEffectiveDateTimeChange}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "endOfShift":
        return (
          <div>
            <div className="line2-column-modal-slider">
              <div
                className="label-textfield"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                  paddingLeft: "0px",
                  paddingBottom: "0px",
                }}
              >
                {translate("NoteContent")}
              </div>
              <TextField
                value={noteContent}
                onChange={handleNoteContentChange}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                  // backgroundColor: "#f2eeef",
                }}
                placeholder={translate("TypeNoteHere")}
                multiline
                rows={12}
              />
            </div>
            <div className="line3-modal-mobile-bis">
              {console.log("shiftStartRaw:", shiftStartRaw)}

              <div style={{ marginLeft: "0px" }}>
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "20px",
                    paddingLeft: "10px",
                    paddingBottom: "0px",
                  }}
                >
                  {translate("StartOfShift")}
                </div>
                <DatePickerWithTimeComponentNoTitleNoMargin
                  value={shiftStartRaw}
                  onChange={handleShiftStartRawChange}
                  // title="Start of Shift"
                />
              </div>

              <div style={{}}>
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "20px",
                    paddingLeft: "10px",
                    paddingBottom: "0px",
                  }}
                >
                  {translate("StartOfShift")}
                </div>
                <DatePickerWithTimeComponentNoTitleNoMargin
                  value={shiftEndRaw}
                  onChange={handleShiftEndRawChange}
                  // title="End of Shift"
                />
              </div>
            </div>
            <div
              // className="line3-modal-mobile-bis"
              style={{ width: "50%", paddingLeft: "20px" }}
            >
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "20px",
                  paddingLeft: "10px",
                  paddingBottom: "0px",
                }}
              >
                {translate("SelectedStaff")}
              </div>
              <DropDownSpecificStaff
                value={staff}
                onChange={handleStaffChange}
                // title="Select Staff"
              />
            </div>
            <div
              // className="line3-modal"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                paddingLeft: "5px",
              }}
            >
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "20px",
                  paddingLeft: "20px",
                  paddingBottom: "5px",
                }}
              >
                {translate("EffectiveDateTime")}
              </div>
              <div style={{ paddingLeft: "15px" }}>
                <DatePickerWithTimeComponentNoTitle
                  title={translate("EffectiveDateTime")}
                  value={effectiveDateTime}
                  onChange={handleEffectiveDateTimeChange}
                />
              </div>
            </div>
          </div>
        );

      case "aftercareNote":
        return (
          <div>
            <div className="inputAndLabelModalContainerTitle2">
              <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  {translate("ClientName")}
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginTop: "10px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    border: errors.clientName
                      ? "1px solid red"
                      : "1px solid lightgrey",
                  }}
                >
                  <SmallClientChipV2LargeMobile
                    firstName={props.clientFirstName}
                    lastName={props.clientLastName}
                    avatar="1"
                    clientPic={props.clientPic}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  marginTop: "0px",
                  height: "75%",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <div className="line2-column-modal">
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      paddingLeft: "15px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("NoteContent")}
                  </div>
                  <TextField
                    name="noteContent"
                    value={noteContent}
                    onChange={handleNoteContentChange}
                    style={{
                      width: "95%",
                      borderRadius: "5px",
                      borderColor: errors.noteContent ? "red" : "default",
                    }}
                    placeholder="Type aftercare session note here"
                    multiline
                    rows={14}
                    error={!!errors.noteContent}
                    helperText={errors.noteContent}
                  />
                </div>
                <div
                  // className="line3-modal"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    marginBottom: "40px",
                  }}
                >
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      marginTop: "20px",
                      paddingLeft: "20px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("EffectiveDateTime")}
                  </div>
                  <div
                    style={{
                      paddingLeft: "15px",
                      borderColor: errors.effectiveDateTime ? "red" : "default",
                    }}
                  >
                    <DatePickerWithTimeComponentNoTitle
                      title={translate("EffectiveDateTime")}
                      value={effectiveDateTime}
                      onChange={handleEffectiveDateTimeChange}
                      error={!!errors.effectiveDateTime}
                      helperText={errors.effectiveDateTime}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "familyNote":
        return (
          <div>
            <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                {translate("ClientName")}
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  marginTop: "10px",
                  width: "100%",
                  border: "1px solid lightgrey",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SmallClientChipV2LargeMobile
                  firstName={props.clientFirstName}
                  lastName={props.clientLastName}
                  avatar="1"
                  clientPic={props.clientPic}
                />
              </div>
            </div>

            <div className="line2-column-modal">
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  paddingLeft: "10px",
                  paddingBottom: "5px",
                }}
              >
                {translate("NoteContent")}
              </div>
              <TextField
                name="quickNote"
                value={noteContent}
                onChange={handleNoteContentChange}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                }}
                placeholder="Type quick session note here"
                multiline
                rows={12}
              />
            </div>
            <div className="line3-modal-mobile"></div>
            <div
              // className="line3-modal"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                paddingBottom: "0px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "20px",
                    paddingLeft: "15px",
                    paddingBottom: "5px",
                  }}
                >
                  {translate("EffectiveDateTime")}
                </div>
                <div style={{ paddingLeft: "10px" }}>
                  <DatePickerWithTimeComponentNoTitle
                    title={translate("EffectiveDateTime")}
                    value={effectiveDateTime}
                    onChange={handleEffectiveDateTimeChange}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                  paddingRight: "25px",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "20px",
                    paddingLeft: "15px",
                    paddingBottom: "5px",
                  }}
                >
                  {translate("FamilyNoteRelationship")}
                </div>
                <div style={{ width: "90%", paddingLeft: "10px" }}>
                  <DropDownComponentNoTitleNoMargin
                    title={translate("FamilyNoteRelationship")}
                    api="livingWith"
                    value={relationship}
                    onChange={handleRelationshipChange}
                  />
                </div>
              </div>
            </div>
            <div className="main-upload-container">
              <UploaderDocForNoteV2
                handleFileChange={handleFilesChange}
                files={files}
                handleFileRemove={handleFileRemove}
              />

              {fileUrls.length > 0 && (
                <UploadedFilesComponentV2
                  fileLinks={fileUrls}
                  // deleteFile={(fileUrl, fileName, noteId) =>
                  //   props.deleteFile(fileUrl, fileName, noteId)
                  // }
                  deleteFile={(fileUrl, fileName, noteId) =>
                    deleteFile(fileUrl, fileName, noteId)
                  }
                  noteId={noteId}
                />
              )}
            </div>
          </div>
        );

      case "groupNote":
        return (
          <div>
            <div className="inputAndLabelModalContainerTitle2">
              <div style={{ paddingLeft: "10px", paddingRight: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      paddingLeft: "5px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("GroupTopic")}
                  </div>

                  <InputComponentNoTitleNomargin
                    isRequired={true}
                    title="Group topic"
                    width="300px"
                    value={groupTopic}
                    onChange={handleGroupTopicChange}
                  />
                </div>
              </div>

              <div
                // className="line3-modal"
                style={{
                  paddingLeft: "15px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignContent: "start",
                  width: "50%",
                  paddingTop: "10px",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                    width: "300px",
                  }}
                >
                  {translate("GroupDateStartTime")}
                </div>
                <div style={{ paddingTop: "5px", paddingLeft: "5px" }}>
                  <DatePickerWithTimeComponentNoTitleNoMargin
                    isRequired={true}
                    value={effectiveDateTime}
                    title="Group Date and start time"
                    width="400px"
                    onChange={handleEffectiveDateTimeChange}
                    leftMargin="none"
                  />
                </div>
              </div>
              <div
                style={{
                  paddingLeft: "10px",
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "10px",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                    paddingLeft: "5px",
                  }}
                >
                  {translate("TypeOfGroup")}
                </div>
                <DropDownComponentSortedNoTitle
                  isRequired={true}
                  api="groupType"
                  title="Type of group"
                  value={groupType}
                  onChange={handleGroupTypeChange}
                />

                {groupType === "Other" && (
                  <InputComponent
                    title="if other, describe"
                    width="auto"
                    value={otherTypeGroupNote}
                    onChange={handleOtherTypeGroupNoteChange}
                  />
                )}
              </div>

              <div
                // className="line2-column-modal"
                style={{ paddingLeft: "20px", paddingTop: "20px" }}
              >
                <div
                  // className="label-textfield"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "0px",
                    paddingBottom: "5px",
                    // backgroundColor: "lightyellow",
                  }}
                >
                  {translate("GroupNote")}
                  <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
                </div>
                <TextField
                  style={{
                    width: "95%",
                    borderRadius: "5px",
                  }}
                  placeholder={translate("TypeGroupNoteHere")}
                  multiline
                  rows={10}
                  value={noteContent}
                  onChange={handleNoteContentChange}
                />
              </div>
              <div className="line2-column-modal">
                <div
                  className="label-textfield"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "0px",
                    paddingBottom: "5px",
                  }}
                >
                  {translate("ClientsNotInAttendance")}
                  <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
                </div>
                <TextField
                  style={{
                    width: "95%",
                    borderRadius: "5px",
                    // backgroundColor: "#f2eeef",
                  }}
                  placeholder="Type names here (first name / or preferred name and first initial of last name) and reason why client is not in group, if known..."
                  multiline
                  rows={4}
                  value={notInAttendance}
                  onChange={handleNotInAttendanceChange}
                />
              </div>
              <div
                // className="line3-modal"
                style={{
                  // paddingLeft: "10px",
                  // marginBottom: "20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  marginBottom: "30px",
                }}
              ></div>
            </div>
          </div>
        );

      case "handoverNote":
        return (
          <div>
            <div
              style={{
                width: "100%",
                marginTop: "0px",
                height: "75%", // overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <div className="line2-column-modal-handover">
                <div
                  className="tab-form-container-handover"
                  style={{ marginTop: "0px" }}
                >
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("ImmigrationAppointment")}
                    </div>
                    <TextField
                      value={immigrationAppointment}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) =>
                        setImmigrationAppointment(e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("DischargesFlights")}
                    </div>
                    <TextField
                      value={dischargeSwot}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setDischargeSwot(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("NewClients")}
                    </div>
                    <TextField
                      value={newClients}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setNewClients(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("PsychiatristAppointments")}
                    </div>
                    <TextField
                      value={medicalInfos}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setMedicalInfos(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("HospitalAppointments")}
                    </div>
                    <TextField
                      value={hospitalAppointment}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setHospitalAppointment(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("Outings")}
                    </div>
                    <TextField
                      value={residentialClientMovements}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) =>
                        setResidentialClientMovements(e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("ZoomSessionAssistance")}
                    </div>
                    <TextField
                      value={zoomSessionAssistance}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setZoomSessionAssistance(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("StaffToday")}
                    </div>
                    <TextField
                      value={staffToday}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setStaffToday(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("Overnight")}
                    </div>
                    <TextField
                      value={overnight}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setOvernight(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("NumberOfClients")}
                    </div>
                    <TextField
                      value={numberOfClient}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setNumberOfClient(e.target.value)}
                    />
                  </div>
                </div>
                <div className="tab-form-container-handover">
                  <div
                    className="textfield-and-label-container100"
                    style={{ marginBottom: "10px" }}
                  >
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("Swot")}
                    </div>
                    <TextField
                      value={swot}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder="..."
                      multiline
                      rows={5}
                      onChange={(e) => setSwot(e.target.value)}
                    />
                  </div>
                  <div className="textfield-and-label-container100">
                    <div
                      className="label-textfield-handover"
                      style={{ color: "black", fontWeight: "600" }}
                    >
                      {translate("GeneralAnnouncement")}
                    </div>
                    <TextField
                      value={generalAnnouncement}
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                      }}
                      placeholder={translate("TypeMedicalNoteHere")}
                      multiline
                      rows={5}
                      onChange={(e) => setGeneralAnnouncement(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div
                // className="line3-modal"
                style={{
                  paddingLeft: "10px",
                  marginTop: "15px",
                  marginBottom: "40px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    paddingLeft: "10px",
                  }}
                >
                  {translate("EffectiveDateTime")}
                </div>
                <div style={{ paddingLeft: "5px" }}>
                  <DatePickerWithTimeComponentNoTitle
                    value={effectiveDateTime}
                    onChange={handleEffectiveDateTimeChange}
                    title={translate("EffectiveDateTime")}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "medicalNote":
        return (
          <div>
            <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                {translate("ClientName")}
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  marginTop: "10px",
                  width: "100%",
                  border: "1px solid lightgrey",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SmallClientChipV2LargeMobile
                  firstName={props.clientFirstName}
                  lastName={props.clientLastName}
                  avatar="1"
                  clientPic={props.clientPic}
                />
              </div>
            </div>
            <div className="line2-column-modal">
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  paddingLeft: "10px",
                  paddingBottom: "5px",
                }}
              >
                {translate("NoteContent")}
              </div>
              <TextField
                name="quickNote"
                value={noteContent}
                onChange={handleNoteContentChange}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                }}
                placeholder="Type quick session note here"
                multiline
                rows={14}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div
                className="label-textfield-handover"
                style={{
                  color: "black",
                  fontWeight: "600",
                  marginTop: "20px",
                  paddingLeft: "20px",
                  paddingBottom: "5px",
                }}
              >
                {translate("EffectiveDateTime")}
              </div>
              <div style={{ paddingLeft: "15px" }}>
                <DatePickerWithTimeComponentNoTitle
                  title={translate("EffectiveDateTime")}
                  value={effectiveDateTime}
                  onChange={handleEffectiveDateTimeChange}
                />
              </div>
            </div>
            <div className="main-upload-container">
              <UploaderDocForNoteV2
                handleFileChange={handleFilesChange}
                files={files}
                handleFileRemove={handleFileRemove}
              />
              {/* <UploadedFilesComponent
                fileLinks={fileUrls}
                deleteFile={(fileUrl, fileName, noteId) =>
                  props.deleteFile(fileUrl, fileName, noteId)
                }
                noteId={noteId}
              /> */}
              {fileUrls.length > 0 && (
                <UploadedFilesComponentV2
                  fileLinks={fileUrls}
                  // deleteFile={(fileUrl, fileName, noteId) =>
                  //   props.deleteFile(fileUrl, fileName, noteId)
                  // }
                  deleteFile={(fileUrl, fileName, noteId) =>
                    deleteFile(fileUrl, fileName, noteId)
                  }
                  noteId={noteId}
                />
              )}
            </div>
          </div>
        );

      case "quickNote":
        return (
          <div>
            <div className="inputAndLabelModalContainerTitle2">
              <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  {translate("ClientName")}
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginTop: "10px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <SmallClientChipV2LargeMobile
                    firstName={props.clientFirstName}
                    lastName={props.clientLastName}
                    avatar="1"
                    clientPic={props.clientPic}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  marginTop: "0px",
                  height: "75%",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <div className="line2-column-modal">
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      paddingLeft: "10px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("NoteContent")}
                  </div>
                  <TextField
                    name="quickNote"
                    value={noteContent}
                    onChange={handleNoteContentChange}
                    style={{
                      width: "95%",
                      borderRadius: "5px",
                      // backgroundColor: "#f2eeef",
                    }}
                    placeholder="Type quick session note here"
                    multiline
                    rows={14}
                  />
                </div>
                <div
                  // className="line3-modal"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      marginTop: "20px",
                      paddingLeft: "20px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("EffectiveDateTime")}
                  </div>
                  <div style={{ paddingLeft: "15px", marginBottom: "40px" }}>
                    <DatePickerWithTimeComponentNoTitle
                      title={translate("EffectiveDateTime")}
                      value={effectiveDateTime}
                      onChange={handleEffectiveDateTimeChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case "therapyNote":
        return (
          <div>
            <div className="inputAndLabelModalContainerTitle2">
              <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                <div
                  className="label-textfield-handover"
                  style={{
                    color: "black",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  {translate("ClientName")}
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    marginTop: "10px",
                    width: "100%",
                    border: "1px solid lightgrey",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <SmallClientChipV2LargeMobile
                    firstName={props.clientFirstName}
                    lastName={props.clientLastName}
                    avatar="1"
                    clientPic={props.clientPic}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  marginTop: "0px",
                  height: "75%",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <div className="line2-column-modal">
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      paddingLeft: "10px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("NoteContent")}
                  </div>
                  {/* <div className="label-textfield">Note content</div> */}
                  <TextField
                    value={noteContent}
                    onChange={handleNoteContentChange}
                    style={{
                      width: "95%",
                      borderRadius: "5px",
                      // backgroundColor: "#f2eeef",
                    }}
                    placeholder="Type 1 to 1 therapy session note here"
                    multiline
                    rows={14}
                  />
                </div>

                <div
                  // className="line3-modal"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    className="label-textfield-handover"
                    style={{
                      color: "black",
                      fontWeight: "600",
                      marginTop: "20px",
                      paddingLeft: "20px",
                      paddingBottom: "5px",
                    }}
                  >
                    {translate("EffectiveDateTime")}
                  </div>
                  <div style={{ paddingLeft: "15px", marginBottom: "40px" }}>
                    <DatePickerWithTimeComponentNoTitle
                      title={translate("EffectiveDateTime")}
                      value={effectiveDateTime}
                      onChange={handleEffectiveDateTimeChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
  }
}

export default NotesContainerCompactMobileEditContent;
